import { Card } from "../ui-bits";
import { useAuth } from "../../context/AuthContext";
import { User } from "lucide-react";
import Pagos from "../Pagos";
import BajaSuscripcion from "../BajaSuscripcion";
import CreditSpending from "../CreditSpending";

export default function TabConfig() {
  const { user } = useAuth();

  const inputCls = "w-full border-2 border-slate-300 rounded-lg px-4 py-3 text-lg bg-white focus:border-blue-600 focus:ring-4 focus:ring-blue-600/20 outline-none";

  // Aquí había un bloque de "Claves de API" (Pexels y YouTube) que el usuario nunca rellena: es
  // una tarea de administración de sistemas en una pantalla de producto, y pedirle a alguien que
  // vino a hacer vídeos que se dé de alta en console.cloud.google.com no tiene defensa. Ambas
  // claves siguen existiendo del lado del servidor (las del sistema), así que quitar el
  // formulario no cambia el comportamiento: solo deja de ofrecer algo que nadie usaba.
  //
  // Con él se fue el botón de guardar, que solo servía para esas dos claves. Si algún día vuelve
  // a haber algo que el usuario configure aquí, vuelve el botón con ello.
  return (
    <div className="space-y-6 max-w-2xl mx-auto">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900">Configuración</h1>
        <p className="text-lg text-slate-600 mt-1">Tu cuenta y tus pagos.</p>
      </div>

      <Card className="p-6 space-y-3">
        <h3 className="text-xl font-semibold text-slate-900 flex items-center gap-2"><User size={22} className="text-blue-600" /> Cuenta</h3>
        <div>
          <label className="block text-base font-semibold text-slate-800 mb-2">Email</label>
          <input data-testid="account-email" value={user?.email || ""} readOnly className={`${inputCls} bg-slate-50 text-slate-500`} />
        </div>
      </Card>

      <CreditSpending />
      <Pagos />

      {/* La baja va al FINAL y a la vista, no escondida tras un enlace diminuto: quien busca
          cancelar y no lo encuentra no se queda, escribe a soporte enfadado o pone una
          reclamación en la tarjeta. Y va después del historial de pagos a propósito — lo último
          que ve antes de decidir es lo que ha pagado y lo que ha recibido por ello. */}
      <BajaSuscripcion />

      <p className="text-base text-slate-400 text-center">YTMethod · versión 2.0</p>
    </div>
  );
}
